import React, {Component} from 'react';
import { connect } from "react-redux"
import Form from './Form';
import { host } from './config';

import './FormContainer.css';
import { GAME_STATUS_HINT_CLICK, GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK } from '../actions/game';

class FormContainer extends Component{

  constructor(props) {
    super(props);

    this.defaultStatus = 0;
    this.storageName = 'chainreactionwebgame';
    this.entryPointValue = 'chainreactionwebgame';
    this.apiUrl = '/api/v1/cm/add-subscriber';
    this.emailListType = 'chain-reaction-webgame';

    this.state = {
      status: this.defaultStatus,
      result: null,
      error: null,
      data: {},
      showResults: false,
      prize: null,
    }

    this.formSubmit = this.formSubmit.bind(this);
  }

  formSubmit(jsonData) {

    // evtTrack('form-submit');

    const json = Object.assign({type: this.emailListType}, jsonData);

    fetch(host + this.apiUrl, {
      method: 'POST',
      body: JSON.stringify(json),
    })
    .then((response) => {
      this.setState({status: response.status});

      return response.json();
    })
    .then((result) => {
      console.log('fetch results:', result);

      this.setState({
        error: result.error || this.state.error,
        result, 
        data:json, 
        showResults: !(result.error && result.error.Message),
        prize: result.success || null
      });
      
      window.localStorage.setItem(this.storageName,JSON.stringify(json));

      !result.error && this.props.handleNewsletterSubmit();
    })
    .catch((error) => {
      this.setState({result: error, data:json});
    });

  }

  renderForm() {

    const {
      data,
      error,
      showResults
    } = this.state;

    if (showResults) {
      return null;
      // return <FormResults 
      //           status={status} 
      //           message={result}
      //           data={data}
      //           />
    }
    
    return <Form
      handleSubmit={this.formSubmit}
      submitError={error}
      data={data}
      isHint={this.props.gameStatus === GAME_STATUS_HINT_CLICK}
      isRevealAllAnswer={this.props.gameStatus === GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK}
      />
  }

  componentDidMount() {
    const data = JSON.parse(window.localStorage.getItem(this.storageName)) || this.state.data,
      showNewsletter =  this.expireCookie(data.lastSubmission);

    //put logic to show form based on when user last filled out form
    this.props.handleShowNewsletter(showNewsletter);
    this.setState({data});
  }

  expireCookie(date) {

    if (!date) {
      return true;
    } 

    const now = Date.now(),
      timePassed = now - date,
      fortyFiveDays = 60 * 60 * 24 * 45 * 1000;

    return timePassed > fortyFiveDays;
  }

  render() {

    const formContainerClassName = "form-container";

    return (
      <div id="form-container" className={formContainerClassName}>
        { this.renderForm() }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  gameStatus: state.game.status
});

const mapDispatchToProps = dispatch => ({
});;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormContainer)